import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lcm-error-page',
  imports: [],
  template: `<div class="error-container">
    <h1 class="error-code">404</h1>
    <p class="error-info">Opps, it seems that this page does not exist.</p>
  </div>`,
})
export class ErrorPage {}
